module.exports = __webpack_public_path__ + "img/map_3.da69d2c2.png";